'use strict'
import { KsAnimate1, KsAnimate2, KsAnimate3, KsAnimate4 } from './ks_animate';
import About from './about';
import Contact from './contact';
import Research from './research';
import Methods from './methods';
import UrlUtils from './urlUtils';

export default class Navigation {
    constructor() {
        this.createEvents();
        this.createPages();
    }
    createPages() {
        this.ksa1 = new KsAnimate1();
        this.ksa2 = new KsAnimate2();
        this.ksa3 = new KsAnimate3();
        this.ksa4 = new KsAnimate4();
        this.contact = new Contact();
        this.about = new About();
        this.research = new Research();
        this.methods = new Methods();
    }
    createEvents() {
        // navigation goes through static event, so we can call it from anywhere
        $('.btn_nav').not('.active').click((e) => {
            window.staticEvents.emit('navigate',$(e.currentTarget).attr('data-class'));
        });
        $('.cell1').not('.active').click(() => {
            window.staticEvents.emit('navigate','ks/1');
        });
        $('.cell2').not('.active').click(() => {
            window.staticEvents.emit('navigate','ks/2');
        });
        $('.cell3').not('.active').click(() => {
            window.staticEvents.emit('navigate','ks/3');
        });
        $('.bottom2').not('.active').click(() => {
            window.staticEvents.emit('navigate','ks/4');
        });
    }
    hideContent() {
        this.about.hide();
        this.contact.hide();
        this.research.hide();
        this.methods.hide();
        this.ksa1.hide();
        this.ksa2.hide();
        this.ksa3.hide();
        this.ksa4.hide();
    }
    navigateHome() {
        $('.container').find('.small').hide();
        $('.top').removeClass('small');
        $('.middle').removeClass('small');
        $('.container').show();
        $('.content').hide();
        $('.container.questions').hide();
        UrlUtils.setUrl('/home');
        this.hideContent();
    }
    makeSmall(questions=true) {
        $('.top').addClass('small');
        $('.middle').addClass('small');
        $('.container.small').find('.small').show();
        if (questions) {
            $('.container.questions').show();
        } else {
            $('.container.questions').hide();
        }
        $('.bottom2').hide();
        $('.bottom').hide();
        this.hideContent();
    }
    navigateKs(part) {
        this.makeSmall();

        switch (part) {
            case "1":
                this.ksa1.show();
                break;
            case "2":
                this.ksa2.show();
                break;
            case "3":
                this.ksa3.show();
                break;
            case "4":
                this.ksa4.show();
                break;
            default:
                {
                    part = "1";
                    this.ksa1.show();
                }
                break;
        }
        UrlUtils.setUrl(`/ks/${part}`);
    }
    navigateAbout(part='3') {
        const allowed = ['3','0'];
        if (!allowed.includes(part)) {
            part = '3';
        }
        this.makeSmall();
        this.about.show(part);
        UrlUtils.setUrl(`/about/${part}`);
    }
    navigateContact() {
        this.makeSmall(false);
        this.contact.show();
        UrlUtils.setUrl(`/contact`);
    }
    navigateResearch(part='1') {
        const allowed = ['1','2','3'];
        if (!allowed.includes(part)) {
            part = '1';
        }
        this.makeSmall();
        this.research.show(part);
        UrlUtils.setUrl(`/research/${part}`);
    }
    navigateMethods(part='1') {
        const allowed = ['1','2'];
        if (!allowed.includes(part)) {
            part = '1';
        }
        this.makeSmall();
        this.methods.show(part);
        UrlUtils.setUrl(`/methods/${part}`);
    }
    navigate(data) {
        const address = data.split("/");
        $('.btn_nav').removeClass('active');
        $(`.btn_${address[0]}`).not('.active').addClass('active');
        switch (address[0]) {
            case "home":
                this.navigateHome();
                break;
            case "ks":
                this.navigateKs(address[1]);
                break;
            case "about":
                this.navigateAbout(address[1]);
                break;
            case "contact":
                this.navigateContact();
                break;
            case "research":
                this.navigateResearch(address[1]);
                break;
            case "methods":
                this.navigateMethods(address[1]);
                break;
            default:
                break;
        }
        const track = ['navigate'];
        address.forEach((e, i) => {
            track.push(e);
        });
        //window.staticEvents.emit('trackEvent', track);
        window.staticEvents.emit('trackPageView', track[1]);
        window.staticEvents.emit('loaded');
        if(!!window.performance && window.performance.navigation.type == 2)
        {
                window.location.reload();
        }
    }
}
